module.exports = __webpack_public_path__ + "svg/new-diners-big.238bd6a0288cc4e868f474cb4ef3defa.svg";